module.exports = __webpack_public_path__ + "static/media/multifamily_strategy2.d9c2b457.jpg";